import React from "react";
import ModalFormTransporte from "./ModalFormTransporte";

const ModalTransporte = ({ show, handleClose, transporte }) => {
  return (
    <ModalFormTransporte show={show} handleClose={handleClose} transporte={transporte} />
  );
};

export default ModalTransporte;
